import React, { useState } from 'react';
import { Button, Input, Select } from 'antd';
import { ArrowRightOutlined } from "@ant-design/icons";

const { TextArea } = Input;
const { Option } = Select;

const StepBasicInfo = ({ onNext, onBack, formData, updateField }) => {
  const [errors, setErrors] = useState({});

  const handleNext = () => {
    const nextErrors = {
      ruleName: !formData.ruleName?.trim(),
      storefront: !formData.storefront,
      ruleDescription: !formData.ruleDescription?.trim(),
    };
    setErrors(nextErrors);

    if (Object.values(nextErrors).some(Boolean)) return;
    onNext();
  };

  const handleFieldChange = (field, value) => {
    updateField(field, value);
    if (errors[field]) setErrors((current) => ({ ...current, [field]: false }));
  };

  return (
    <div className='step-container'>
      <div className='step-content'>
        <div className='step-header'>          
          <div className='step-title'>Basic Info</div>
          <div className='step-subtitle'>Identity and scope for this rule.</div>
        </div>

        <div className='step-form'>
          <div className='step-group'>
            <div className='step-form-label'>Rule Name <span style={{ color: '#ff4d4f' }}>*</span></div>
            <Input
              placeholder="Enter Rule Name"
              value={formData.ruleName}
              onChange={(e) => handleFieldChange('ruleName', e.target.value)}
              status={errors.ruleName ? 'error' : undefined}
              className='Input-border w-100'
            />
            {errors.ruleName && <div className='step-form-hint' style={{ color: '#ff4d4f' }}>Rule Name is required.</div>}
          </div>

          <div className='step-group'>
            <div className='step-form-label'>Select Store <span style={{ color: '#ff4d4f' }}>*</span></div>
            <Select
              className='Input-border InputSelect w-100'
              value={formData.storefront || undefined}
              placeholder="Select Store"
              allowClear
              status={errors.storefront ? 'error' : undefined}
              onChange={(value) => handleFieldChange('storefront', value || '')}
            >
              <Option value="UAT">UAT</Option>
              <Option value="US">US</Option>
              <Option value="UK">UK</Option>
              <Option value="DE">DE</Option>
              <Option value="INT">INT</Option>
            </Select>
            {errors.storefront && <div className='step-form-hint' style={{ color: '#ff4d4f' }}>Store is required.</div>}
          </div>

          <div className='step-group'>
            <div className='step-form-label'>Rule Description / Dynamic Rule Text (Customer Facing) <span style={{ color: '#ff4d4f' }}>*</span></div>
            <TextArea
              rows={4}
              maxLength={500}
              showCount
              value={formData.ruleDescription}
              onChange={(e) => handleFieldChange('ruleDescription', e.target.value)}
              status={errors.ruleDescription ? 'error' : undefined}
              style={{ resize: 'none', borderRadius: 8 }}
              className='Input-border w-100'
            />
            <div
              className='step-form-hint'
              style={formData.ruleDescription?.length >= 500 ? { color: '#ff4d4f' } : undefined}
            >
              {formData.ruleDescription?.length >= 500 ? 'Maximum 500 characters reached.' : 'Max 500 Characters'}
            </div>
            {errors.ruleDescription && <div className='step-form-hint' style={{ color: '#ff4d4f' }}>Rule Description is required.</div>}
          </div>
        </div>

        <div className='step-footer'>
          <Button type="primary" className='btn-p' onClick={handleNext}>
            Next: Benefit & Mechanic
            <ArrowRightOutlined />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StepBasicInfo;
